var React = require('react');

function InfoInvert (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#1b1b1b;}")),React.createElement("title",{"key":1},"info_invert"),React.createElement("path",{"className":"cls-1","d":"M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM8.22,3.74a.91.91,0,0,1,.33-.33A.87.87,0,0,1,9,3.29a.85.85,0,0,1,.44.12.94.94,0,0,1,.33.33.85.85,0,0,1,.12.44.87.87,0,0,1-.12.45A.91.91,0,0,1,9.44,5,.87.87,0,0,1,9,5.08.88.88,0,0,1,8.55,5a.87.87,0,0,1-.33-.33.88.88,0,0,1-.12-.45A.87.87,0,0,1,8.22,3.74ZM10.79,14l-1.7-.05L7.4,14v-.29A1.78,1.78,0,0,0,8,13.62a.6.6,0,0,0,.33-.31,1.42,1.42,0,0,0,.11-.61V8.32a1.51,1.51,0,0,0-.24-.94,1,1,0,0,0-.83-.29V6.79q.44,0,.87,0a4.64,4.64,0,0,0,1.46-.19V12.7a1.42,1.42,0,0,0,.11.61.6.6,0,0,0,.33.31,1.78,1.78,0,0,0,.63.09Z","key":2})]);
}

InfoInvert.displayName = "InfoInvert";

InfoInvert.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = InfoInvert;

InfoInvert.default = InfoInvert;



//////////////////
// WEBPACK FOOTER
// ../node_modules/svg-react-loader/lib/loader.js!./assets/images/fullscreen-store/info_invert.svg
// module id = 226
// module chunks = 1 2 3 4